import Spinner from '@/components/common/Spinner';
import TrackingPixels from '@/components/pixels/TrackingPixels';
import { CheckoutProvider } from '@/contexts/CheckoutContext';
import { CheckoutModeProvider } from '@/contexts/CheckoutModeContext';
import { NotificationProvider } from '@/contexts/NotificationContext';
import CheckoutPage from '@/pages/CheckoutPage';
import CheckoutPreviewPage from '@/pages/CheckoutPreviewPage';
import NotificationToasts from '@/components/notifications/NotificationToasts';
import { usePostHogSessionReplay } from '@/hooks/usePostHogSessionReplay';
import { Suspense } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Toaster } from 'sonner';
import './App.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

const baseUrl = import.meta.env.VITE_BRANDING_IMAGES_URL;
const sizes = ['16x16', '32x32'];
sizes.forEach((size) => {
  const link = document.createElement('link');
  link.setAttribute('rel', 'icon');
  link.setAttribute('type', 'image/png');
  link.setAttribute('sizes', size);
  link.setAttribute('href', `${baseUrl}favicon/favicon-${size}.png`);
  document.head.appendChild(link);
});

const appleIcon = document.createElement('link');
appleIcon.setAttribute('rel', 'apple-touch-icon');
appleIcon.setAttribute('sizes', '180x180');
appleIcon.setAttribute('href', `${baseUrl}favicon/apple-touch-icon.png`);
document.head.appendChild(appleIcon);

const CheckoutPageWithSessionReplay = () => {
  usePostHogSessionReplay();
  return <CheckoutPage />;
};

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <NotificationProvider>
        <BrowserRouter>
          <Routes>
            <Route
              path="/preview"
              element={
                <Suspense fallback={<Spinner />}>
                  <CheckoutModeProvider preview={true}>
                    <CheckoutPreviewPage />
                  </CheckoutModeProvider>
                </Suspense>
              }
            />
            <Route
              path=":id"
              element={
                <Suspense fallback={<Spinner />}>
                  <CheckoutModeProvider preview={false}>
                    <CheckoutProvider>
                      <CheckoutPageWithSessionReplay />
                      <TrackingPixels />
                    </CheckoutProvider>
                  </CheckoutModeProvider>
                </Suspense>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster richColors />
        <div id="modal-root" />
        <div id="toast-root" />
        <NotificationToasts />
        <div id="chat-card-root" />
      </NotificationProvider>
    </QueryClientProvider>
  );
}

export default App;
